var render = function render(){var _vm=this,_c=_vm._self._c;return _c('portal',{staticClass:"portal",attrs:{"selector":"#event-portal"}},[_c('ConfirmationDialogProvider',[_c('EventPage')],1),_c('Lightbox',{attrs:{"service":_vm.lightboxService}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }